import { HotWorkSection, SignatureType } from "../../../common/enums";
import CounterSignatureRequest from "../../CounterSignatureRequest";
import { formElement } from "../../forms/FormElement";
import HotWorkConditionsFormState from "../../forms/Permits/EnergyHarbourPermit/HotWorkFormState";
import Signature, { Signature_normalize } from "../../Signature";

export type HotWorkConditions = {
    isPhoneClassified: boolean;
    isGasDeclared: boolean;
    isContinousGasMeasurements: boolean;
    isSparkProtected: boolean;
    isWellsProtected: boolean;
    isCleanedUpForFireProtection: boolean;
    workPlaceMonitoredIsChecked: boolean;
    fireGuardCount: string;
    postWorkPlaceMonitoredHours: string;
    fireDetectorsTurnedOffIsChecked: boolean;
    fireDetectorsTurnedOffSectionNames: string | undefined;
    isWaterFromFirePostInPlace: boolean;
    fireExtinguisherIsChecked: boolean;
    fireExtinguisherCount: number | undefined;
    fireExtinguisherKg: number | undefined;
    noHotworkWithFlammableMaterialsUsedSub30Celcius: boolean;
    distanceFromPumpsAndVentilationMeters: number;
    noHotWorkCloseToShipsHandlingFlammables: boolean;
    noHotWorkAtQuay: boolean;
    isShipInformedAboutFlammablesSub30Celcius: boolean;
    isCloseDepotInformedBeforeWorkIsStarted: boolean;
    informCloseDepotBeforeWorkIsChecked: boolean;

    nameOfCloseDepotBeforeWorkIsStartedInfo: string | undefined;
    otherInformation: string | undefined;

    counterSignatureRequest: CounterSignatureRequest;
};

export function HotWork_toFormState(hotWorkConditions: HotWorkConditions): HotWorkConditionsFormState {
    const formState: HotWorkConditionsFormState = {
        isPhoneClassified: formElement(hotWorkConditions.isPhoneClassified),
        isGasDeclared: formElement(hotWorkConditions.isGasDeclared),
        isContinousGasMeasurements: formElement(hotWorkConditions.isContinousGasMeasurements),
        isSparkProtected: formElement(hotWorkConditions.isSparkProtected),
        isWellsProtected: formElement(hotWorkConditions.isWellsProtected),
        isCleanedUpForFireProtection: formElement(hotWorkConditions.isCleanedUpForFireProtection),
        workPlaceMonitoredIsChecked: formElement(hotWorkConditions.workPlaceMonitoredIsChecked),
        fireGuardCount: formElement(hotWorkConditions.fireGuardCount),
        postWorkPlaceMonitoredHours: formElement(hotWorkConditions.postWorkPlaceMonitoredHours),
        fireDetectorsTurnedOffIsChecked: formElement(hotWorkConditions.fireDetectorsTurnedOffIsChecked),
        fireDetectorsTurnedOffSectionNames: formElement(hotWorkConditions.fireDetectorsTurnedOffSectionNames),
        isWaterFromFirePostInPlace: formElement(hotWorkConditions.isWaterFromFirePostInPlace),
        fireExtinguisherIsChecked: formElement(hotWorkConditions.fireExtinguisherIsChecked),
        fireExtinguisherCount: formElement(hotWorkConditions.fireExtinguisherCount),
        fireExtinguisherKg: formElement(hotWorkConditions.fireExtinguisherKg),
        noHotworkWithFlammableMaterialsUsedSub30Celcius: formElement(
            hotWorkConditions.noHotworkWithFlammableMaterialsUsedSub30Celcius
        ),
        distanceFromPumpsAndVentilationMeters: formElement(hotWorkConditions.distanceFromPumpsAndVentilationMeters),
        noHotWorkCloseToShipsHandlingFlammables: formElement(hotWorkConditions.noHotWorkCloseToShipsHandlingFlammables),
        noHotWorkAtQuay: formElement(hotWorkConditions.noHotWorkAtQuay),
        isShipInformedAboutFlammablesSub30Celcius: formElement(
            hotWorkConditions.isShipInformedAboutFlammablesSub30Celcius
        ),
        isCloseDepotInformedBeforeWorkIsStarted: formElement(hotWorkConditions.isCloseDepotInformedBeforeWorkIsStarted),
        informCloseDepotBeforeWorkIsChecked: formElement(hotWorkConditions.informCloseDepotBeforeWorkIsChecked),
        nameOfCloseDepotBeforeWorkIsStartedInfo: formElement(hotWorkConditions.nameOfCloseDepotBeforeWorkIsStartedInfo),
        otherInformation: formElement(hotWorkConditions.otherInformation)
    };

    return formState;
}

export function HotWorkConditions_normalize(hotWork: HotWorkConditions): HotWorkConditions {
    const normalizedHotWork: HotWorkConditions = {
        counterSignatureRequest: hotWork.counterSignatureRequest,
        distanceFromPumpsAndVentilationMeters: hotWork.distanceFromPumpsAndVentilationMeters ?? 0,
        fireDetectorsTurnedOffIsChecked: hotWork.fireDetectorsTurnedOffIsChecked ?? false,
        fireDetectorsTurnedOffSectionNames: hotWork.fireDetectorsTurnedOffSectionNames ?? "",
        fireExtinguisherCount: hotWork.fireExtinguisherCount,
        fireExtinguisherKg: hotWork.fireExtinguisherKg,
        fireGuardCount: hotWork.fireGuardCount ?? "",
        fireExtinguisherIsChecked: hotWork.fireExtinguisherIsChecked ?? false,
        isCleanedUpForFireProtection: hotWork.isCleanedUpForFireProtection ?? false,
        isContinousGasMeasurements: hotWork.isContinousGasMeasurements ?? false,
        isGasDeclared: hotWork.isGasDeclared ?? false,
        informCloseDepotBeforeWorkIsChecked: hotWork.informCloseDepotBeforeWorkIsChecked ?? false,
        isCloseDepotInformedBeforeWorkIsStarted: hotWork.isCloseDepotInformedBeforeWorkIsStarted ?? false,
        isPhoneClassified: hotWork.isPhoneClassified ?? false,
        isShipInformedAboutFlammablesSub30Celcius: hotWork.isShipInformedAboutFlammablesSub30Celcius ?? false,
        isSparkProtected: hotWork.isSparkProtected ?? false,
        isWaterFromFirePostInPlace: hotWork.isWaterFromFirePostInPlace ?? false,
        nameOfCloseDepotBeforeWorkIsStartedInfo: hotWork.nameOfCloseDepotBeforeWorkIsStartedInfo ?? "",
        isWellsProtected: hotWork.isWellsProtected ?? false,
        noHotWorkAtQuay: hotWork.noHotWorkAtQuay ?? false,
        noHotWorkCloseToShipsHandlingFlammables: hotWork.noHotWorkCloseToShipsHandlingFlammables ?? false,
        noHotworkWithFlammableMaterialsUsedSub30Celcius:
            hotWork.noHotworkWithFlammableMaterialsUsedSub30Celcius ?? false,
        otherInformation: hotWork.otherInformation ?? "",
        postWorkPlaceMonitoredHours: hotWork.postWorkPlaceMonitoredHours ?? "",
        workPlaceMonitoredIsChecked: hotWork.workPlaceMonitoredIsChecked ?? false
    };

    return normalizedHotWork;
}